<template>
    <div data-testid="count-actions__count-section" class="d-flex align-center dataCount">
        <h6 data-testid="count-actions__count-label" class="font-weight-medium count-label">
            {{ networkLabel }} {{ countLabel }}
        </h6>
        <h3 data-testid="count-actions__count-value" class="font-weight-medium">
            {{ count }}
        </h3>
    </div>
</template>

<script>
export default {
    name: 'CountSection',
    props: {
        count: {
            type: Number,
            required: true
        },
        networkLabel: {
            type: String,
            default: 'Network'
        },
        countLabel: {
            type: String,
            default: 'Count'
        }
    }
}
</script>

<style scoped>
.dataCount {
    width: fit-content;
    border-radius: 8px;
    border: 1px solid var(--grey-900);
    background: #F7F7F7;
    padding: var(--space-3) var(--space-5);
}
.count-label {
    color: var(--grey-900);
}
</style>
